<ol class="breadcrumbs-list" itemscope itemtype="http://schema.org/BreadcrumbList">
  <li class="breadcrumbs-item" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" *ngFor="let item of items; let i = index">
    <a class="breadcrumbs-action" itemprop="item" [attr.href]="item.url"><span itemprop="name">{{item.title}}</span></a>
    <meta itemprop="position" [attr.content]="(i + 1)" />
  </li>
</ol>
